export const literalConstant = {
  API_URL: 'API_URL',
  ABTEST_SUBMISSION_HEADER: 'AbTestConfig',
};
